import { Component, input } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { CamTranslationProject } from '../../../../translation.service';
import { PaymentFlowStatus } from '../../services/dto/payment-flow-status';

export const paymentFlowStatusLabel = (paymentFlowStatus: PaymentFlowStatus) =>
  `project.paymentFlowStatus.${PaymentFlowStatus[paymentFlowStatus]?.toLowerCase() ?? 'unknown'}`;

@Component({
  selector: 'cam-payment-flow-status',
  templateUrl: './payment-flow-status.component.html',
  styleUrl: './payment-flow-status.component.scss',
  imports: [BadgeComponent, TranslatePipe],
})
export class PaymentFlowStatusComponent extends CamBaseComponent {
  status = input.required<number | PaymentFlowStatus>();

  constructor() {
    super();
    CamTranslationProject.getInstance();
  }

  public label() {
    return paymentFlowStatusLabel(this.status());
  }

  public type() {
    switch (this.status()) {
      case PaymentFlowStatus.ReimbursementToClientFromDigiteal:
      case PaymentFlowStatus.ReimbursementToClientFromRequestor:
        return 'orange';
      case PaymentFlowStatus.Success:
        return 'success';
      case PaymentFlowStatus.Error:
        return 'danger';
      case PaymentFlowStatus.Initiated:
        return 'purple';
      case PaymentFlowStatus.Created:
      case PaymentFlowStatus.Unknown:
      default:
        return 'info';
    }
  }
}
